import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Thongkephuluc9 from "components/Thongke/Phuluc9/Phuluc9.js";
export default function Tklaixe() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Tra cứu thông tin phụ lục 9",
            tabContent: <Thongkephuluc9 />,
          },
        ]}
      />
    </div>
  );
}
